import { render, staticRenderFns } from "./ProfilesEdit.vue?vue&type=template&id=a51b542e&"
import script from "./ProfilesEdit.vue?vue&type=script&lang=js&"
export * from "./ProfilesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports